import { AccessToken, UserControllerApi } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

/**
 * @author Shrinivas Mandhare
 */
export const useLogOut = () =>
  useMutationWithLoading((params: AccessToken & { xTENANTID?: string }) =>
    new UserControllerApi(getConfigObject()).logout(params, params.xTENANTID)
  );
